module.exports = __webpack_public_path__ + "img/117.1.9c76eb36.jpg";